// Match Goals — over/under goals odds table (Phase 3 → M2 wave 9). Thin wrapper
// over the shared <MarketTable>; the goals market dataset now comes from app-api
// via `useWidgetData` (was the `getGoalsMarketData` legacyData getter). The
// bookmaker + scope controls stay client-side (they reshape the one fetched
// payload — no refetch).

import { shapeMarketTable } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import MarketTable from "./MarketTable.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface MatchGoalsProps {
  fixture: string;
  /** Bookmaker toggle; defaults to "Pinnacle". */
  bookmaker?: string | null;
  /** Market scope toggle ("Match" | team abbr); defaults to "Match". */
  scope?: string | null;
}

export default function MatchGoals({
  fixture,
  bookmaker,
  scope,
}: MatchGoalsProps) {
  const { data, isPending, isError, refetch } = useWidgetData(
    "match-goals",
    useFixtureKey(fixture)
  );
  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const rows =
    shapeMarketTable(
      data ?? {},
      fixture || "Arsenal v Everton",
      scope || "Match",
      bookmaker || "Pinnacle"
    ) ?? [];
  return <MarketTable wrapperClass="gm-wrapper" rows={rows} />;
}
